import React from 'react';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const CopyQuestionAction = ({ onClick, arialLabel, className, disabled }) => (
  <ButtonWithIcon
    isIcon
    isNaked
    icon="duplicate"
    aria-label={arialLabel}
    data-test-id="copy-question"
    className={className}
    tabIndex={0}
    onClick={onClick}
    disabled={disabled}
  />
);

export default CopyQuestionAction;
